import { useEffect, useState } from 'react'
import { X, CheckCircle, XCircle, Info, AlertCircle } from 'lucide-react'

let toastIdCounter = 0
let addToastCallback = null

export const showToast = (message, type = 'info') => {
  if (addToastCallback) {
    addToastCallback({ message, type, id: ++toastIdCounter })
  }
}

export function Toaster() {
  const [toasts, setToasts] = useState([])

  useEffect(() => {
    addToastCallback = (toast) => {
      setToasts(prev => [...prev, toast])
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== toast.id))
      }, 5000)
    }

    return () => {
      addToastCallback = null
    }
  }, [])

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }

  const getIcon = (type) => {
    switch (type) {
      case 'success': return <CheckCircle size={20} />
      case 'error': return <XCircle size={20} />
      case 'warning': return <AlertCircle size={20} />
      default: return <Info size={20} />
    }
  }

  const getColor = (type) => {
    switch (type) {
      case 'success': return 'bg-green-600'
      case 'error': return 'bg-red-600'
      case 'warning': return 'bg-yellow-600'
      default: return 'bg-blue-600'
    }
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`${getColor(toast.type)} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-[500px] animate-slide-in`}
        >
          {getIcon(toast.type)}
          <p className="flex-1">{toast.message}</p>
          <button
            onClick={() => removeToast(toast.id)}
            className="hover:bg-white hover:bg-opacity-20 rounded p-1"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  )
}
